import { useState } from "react";
import { specials } from "@/mocks/specials";
import { getMoviesBySpecial } from "@/utils/movie";
import { usePageMeta } from "@/hooks/usePageMeta";
import MovieCard from "@/components/feature/MovieCard";

export default function SpecialsPage() {
  const [expanded, setExpanded] = useState<string>(specials[0]?.id ?? "");

  usePageMeta(
    "专题合集 - 秋霞网影视推荐",
    "秋霞网精心策划的影视专题合集，涵盖近期热播、经典回顾、悬疑烧脑、青春成长等主题，帮您发现更多优质影视内容。"
  );

  return (
    <div className="mx-auto w-full max-w-[1280px] px-4 py-6 md:px-6 md:py-8">
      <header className="rounded-xl border border-background-300/60 bg-background-100 px-6 py-8 md:px-8 md:py-10">
        <span className="rounded-full bg-secondary-700 px-3 py-1 text-xs text-primary-400">
          编辑精选
        </span>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          影视专题合集
        </h1>
        <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-500 md:text-base">
          秋霞网为您精心策划了多个影视主题合集，从近期热播到经典回顾，从治愈暖片到悬疑烧脑。
          点击任意专题即可展开该合集下的影视作品，帮助您按主题发现更多想看的好片。
        </p>
      </header>

      <div className="mt-8 space-y-6">
        {specials.map((special) => {
          const items = getMoviesBySpecial(special.id);
          const isOpen = expanded === special.id;
          return (
            <section
              key={special.id}
              className="overflow-hidden rounded-xl border border-background-300/60 bg-background-100"
            >
              <button
                type="button"
                onClick={() => setExpanded(isOpen ? "" : special.id)}
                className="relative block w-full text-left cursor-pointer"
              >
                <div className="relative h-40 w-full overflow-hidden md:h-48">
                  <img
                    src={special.cover}
                    alt={special.title}
                    title={`${special.title} 秋霞网专题合集`}
                    className="h-full w-full object-cover object-center"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-secondary-950/95 via-secondary-950/60 to-secondary-950/20" />
                  <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-8">
                    <div className="flex items-center gap-3">
                      <span className="rounded bg-primary-500 px-2 py-0.5 text-[10px] font-medium text-foreground-950">
                        {items.length} 部作品
                      </span>
                      <span className="text-xs text-foreground-500">
                        {special.subtitle}
                      </span>
                    </div>
                    <h2 className="mt-3 font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
                      {special.title}
                    </h2>
                    <p className="mt-2 line-clamp-2 max-w-2xl text-xs text-foreground-500 md:text-sm">
                      {special.description}
                    </p>
                  </div>
                  <span className="absolute right-5 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-foreground-700/40 bg-background-50/60 text-foreground-900 backdrop-blur">
                    <i
                      className={`text-xl transition-transform ${
                        isOpen ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    />
                  </span>
                </div>
              </button>

              {isOpen && (
                <div className="animate-fade-in border-t border-background-300/60 p-4 md:p-6">
                  {items.length > 0 ? (
                    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
                      {items.map((movie) => (
                        <MovieCard key={movie.id} movie={movie} />
                      ))}
                    </div>
                  ) : (
                    <p className="py-8 text-center text-sm text-foreground-500">
                      该专题暂无影视资源
                    </p>
                  )}
                </div>
              )}
            </section>
          );
        })}
      </div>
    </div>
  );
}